import { ComponentPortal, ComponentType } from '@angular/cdk/portal';
import { Injectable, Injector } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DynFormSection } from '../../../common-shared-module/model/dyn-form/dyn-form-section.model';
import { ProcedureInstanceBase } from '../../../common-shared-module/model/procedure-instance/procedure-instance.model';
import { EFormDefaultComponent } from '../../components/eform/e-form-default/e-form-default.component';
import { DynamicSectionComponent } from '../../components/eform/dynamic-section/dynamic-section.component';
import { EForm, EFormFactory, EFormRegistry, EFormSection, EFormSectionFactory, FormValidationErrorController } from '../../model/eform/eform-api.model';

@Injectable({
	providedIn: 'root'
})
export class EFormFactoryService implements EFormSectionFactory, EFormFactory {

	forms: Map<string, ComponentType<EForm>> = new Map()
	sections: Map<string, ComponentType<EFormSection>> = new Map()

	constructor() {
		this.forms.set("default", EFormDefaultComponent)
		this.sections.set("default", DynamicSectionComponent)
	}

	loadEForm(serviceCode: string, procedureCode: string): ComponentType<EForm> {
		const key = serviceCode + "-" + procedureCode
		let component: ComponentType<EForm> | undefined = this.forms.get(key)
		if (component != null) {
			return component
		}
		return <ComponentType<EForm>>this.forms.get("default")
	}

	loadSection(section: DynFormSection): ComponentType<EFormSection> {
		const key = "" + section.type
		let component: ComponentType<EFormSection> | undefined = this.sections.get(key)
		if (component != null) {
			return component
		}
		return <ComponentType<EFormSection>>this.sections.get("default")
	}

	newEForm(registry: EFormRegistry, procedureInstance: ProcedureInstanceBase, validationError: FormValidationErrorController, serviceCode: string, procedureCode: string): Observable<ComponentPortal<EForm>> {
		let injector = Injector.create({ providers: [{ provide: "CONTAINER_DATA", useValue: { registry: registry, procedureInstance: procedureInstance, sectionErrors: validationError } }] })
		let portal: ComponentPortal<EForm> = new ComponentPortal(this.loadEForm(serviceCode, procedureCode), null, injector)
		return of(portal)
	}

	newEFormSection(section: DynFormSection, procedureInstance: ProcedureInstanceBase, validationError: FormValidationErrorController): Observable<ComponentPortal<EFormSection>> {
		let injector = Injector.create({ providers: [{ provide: "CONTAINER_DATA", useValue: { procedureInstance: procedureInstance, section: section, sectionErrors: validationError } }] })
		let portal: ComponentPortal<EFormSection> = new ComponentPortal(this.loadSection(section), null, injector)
		return of(portal)
	}

}
